import React from 'react'
import { Outlet } from 'react-router-dom'

import { Header } from '@/components/layout'
import { Sidebar } from '@/components/layout'
import { BreadcrumbProvider } from '@/contexts/BreadcrumbProvider'

export const MainLayout: React.FC = () => {
  return (
    <BreadcrumbProvider>
      <div className="flex h-screen bg-gray-50">
        <Sidebar currentModule="assessments" />

        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbProvider>
  )
}

//---------------------

// interface MainLayoutProps {
//   sidebarConfig?: SidebarConfig
//   children: React.ReactNode
// }

// export const MainLayout: React.FC<MainLayoutProps> = ({
//   sidebarConfig = defaultSidebarConfig,
//   children
// }) => {
//   return (
//     <div className="flex h-screen">
//       <Sidebar config={sidebarConfig} />
//       <div className="flex-1 flex flex-col">
//         <Header />
//         <main className="flex-1 overflow-auto bg-gray-50">
//           <PageContainer>{children}</PageContainer>
//         </main>
//       </div>
//     </div>
//   )
// }
